import { ChannelTypeEnum } from '~/enums/conversations';
import { MediaAttachmentList } from '~/interfaces/conversations';
import { MessagesIcon, SMSIcon, WhatsappIcon } from '~/assets/svgIcons';

const getChannelIconById = (channelId: ChannelTypeEnum) => {
  let icon = MessagesIcon;

  switch (channelId) {
    case ChannelTypeEnum.SMS:
      icon = SMSIcon;
      break;
    case ChannelTypeEnum.WHATSAPP:
      icon = WhatsappIcon;
      break;
    case ChannelTypeEnum.MMS:
      icon = SMSIcon;
      break;
    default:
      icon = MessagesIcon;
  }

  return icon;
};

// US (+1) and Canada (+1) share the same country code but are distinguished by NANP area codes.
// Australia uses +61. MMS is not supported outside these regions.
const MMS_SUPPORTED_PREFIXES = ['+1', '+61'];

const isMmsSupportedNumber = (number: string): boolean => {
  if (!number) return false;
  const normalized = number.startsWith('00') ? `+${number.slice(2)}` : number;
  return MMS_SUPPORTED_PREFIXES.some(prefix => normalized.startsWith(prefix));
};

type AttachmentErrorCode =
  | 'MEDIA_TOO_LARGE'
  | 'MEDIA_TOO_LARGE_PROVIDER'
  | 'UNSUPPORTED_MEDIA_TYPE'
  | 'MEDIA_DOWNLOAD_FAILED'
  | 'MEDIA_PROCESSING_FAILED';

const ATTACHMENT_ERROR_MESSAGES: Record<AttachmentErrorCode, string> = {
  MEDIA_TOO_LARGE:
    "This attachment couldn't be received because it's too large.",
  MEDIA_TOO_LARGE_PROVIDER:
    "This attachment couldn't be received because it's too large.",
  UNSUPPORTED_MEDIA_TYPE:
    "This attachment couldn't be received because the file type isn't supported.",
  MEDIA_DOWNLOAD_FAILED: "This attachment couldn't be downloaded.",
  MEDIA_PROCESSING_FAILED: "This attachment couldn't be received.",
};

const getAttachmentErrorMessage = (mediaError: {
  code: AttachmentErrorCode;
  message: string;
}): string => {
  return ATTACHMENT_ERROR_MESSAGES[mediaError.code] ?? mediaError.message;
};

/**
 * SMS drafts with media attachments must be sent as MMS; resolve before building the payload.
 */
const resolveChannelType = (
  channelType: ChannelTypeEnum,
  mediaAttachments: MediaAttachmentList = []
): ChannelTypeEnum => {
  if (channelType === ChannelTypeEnum.SMS && mediaAttachments?.length) {
    return ChannelTypeEnum.MMS;
  }
  return channelType;
};

export {
  getChannelIconById,
  isMmsSupportedNumber,
  getAttachmentErrorMessage,
  resolveChannelType,
};
